import { support_features } from 'data/Pricing/EntrpriseFeatures'
import React from 'react'

const SupportFeatureCard = () => {
  return (
    <div className=" w-full ">
      <div className=" w-full flex flex-col  gap-3 md:gap-4  mb-12 md:mb-[72px]">
        <p className="  text-base  font-semibold text-primary">Support</p>
        <h2 className="h2">Best in class security and compliance</h2>
        <p className=" text-lightGray text-[18px] font-medium  leading-[27px] max-w-screen-md mr-0">
          Tradly protects sensitive data and keeps member information secure with enterprise-grade
          data protection, compliance best practices, and top-notch cloud service standards.
        </p>
      </div>

      <div className=" grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-x-8  gap-y-10 md:gap-y-12">
        {support_features.map((feature) => {
          return (
            <div className=" flex items-start justify-start   flex-col">
              <div className=" mb-6 flex items-center justify-center text-primary h-10 w-10 bg-primary/40  ring-8 ring-primary/10  rounded-full ">
                {feature.icon}
              </div>
              <h4 className=" h4  mb-2">{feature.title} </h4>
              <p className="text-lightGray text-base font-medium  leading-[24px]">
                {feature.description}
              </p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SupportFeatureCard
